/*
 * TC 상품 카드 — 썸네일 이미지 스와이퍼(.tc-p-img)
 * 카드가 있는 페이지에서만 동작. Swiper 전역 준비될 때까지 대기.
 */
(function () {
  function init() {
    var imgs = document.querySelectorAll('.tc-p-img');
    if (!imgs.length) return; // 카드 없으면 폴링도 안 함
    if (typeof Swiper === 'undefined') { setTimeout(init, 50); return; }

    imgs.forEach(function (el) {
      if (el.dataset.swiperInit === '1') return;
      var wrap = el.querySelector('.swiper-wrapper');
      if (!wrap) return;
      // 슬라이드 1개면 스와이퍼 불필요
      if (el.querySelectorAll('.swiper-slide').length < 2) { el.dataset.swiperInit = '1'; return; }
      el.dataset.swiperInit = '1';

      new Swiper(el, {
        slidesPerView: 1,
        loop: false,
        roundLengths: true, /* 소수점 너비 반올림 */
        spaceBetween: 2, /* 옆 슬라이드를 화면 밖으로 밀어 1px 비침 방지 */
        navigation: {
          prevEl: el.querySelector('.tc-p-prev-btn'),
          nextEl: el.querySelector('.tc-p-next-btn'),
        },
      });
    });
  }

  // 퀵애드(장바구니 담기)는 tc-cart-add.js(모듈)가 AJAX로 처리.

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
